import { get2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { AppsmenError, ZipcodeByRadius } from "@/shared/utils/interfaces";
import { useQuery } from "@tanstack/react-query";

const useZipcodesByRadius = (radius: number) => {
  const branch = useBranchId();

  const query = useQuery<ZipcodeByRadius[], AppsmenError>({
    queryKey: ["zipcodes-by-radius", branch, radius],
    queryFn: () => {
      return get2(
        `internal/secure/pos/v1/zipcodes/by/radius/${branch}/${radius}`
      );
    },
    enabled: radius !== 0,
  });

  return query;
};

export default useZipcodesByRadius;
